package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogSpacing() {
    Column {
        Text("Spacing", style = CoreTypography.title)

        SpacingRow("xs", CoreSpacing.xs)
        SpacingRow("sm", CoreSpacing.sm)
        SpacingRow("md", CoreSpacing.md)
        SpacingRow("lg", CoreSpacing.lg)
        SpacingRow("xl", CoreSpacing.xl)
    }
}

@Composable
private fun SpacingRow(
    label: String,
    space: Dp,
) {
    Column {
        Text("$label — $space", style = CoreTypography.body)
        Spacer(modifier = Modifier.height(space))
    }
}
